import React, { useEffect } from "react";
import algoliasearch from "algoliasearch/lite";
import {
  InstantSearch,
  SearchBox,
  Hits,
  Pagination,
  Highlight,
  Snippet,
  Configure,
} from "react-instantsearch";

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
);

function SearchResults({ locale, ...props }) {
  const [initialQuery, setInitialQuery] = React.useState("");

  let text_key = `text_${locale}`;
  let title_key = `title_${locale}`;
  let path_key = `path_${locale}`;

  function getQueryStringValue(key) {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  }
  useEffect(() => {
    setInitialQuery(getQueryStringValue("q"));
  }, [locale]);

  function Hit({ hit }) {
    return (
      <a
        href={`${hit?.[path_key]}`}
        style={{
          color: "black",
          textDecoration: "none",
        }}
      >
        <h4
          style={{
            color: ` #f00f00`,
          }}
        >
          <Highlight attribute={title_key} hit={hit} />
        </h4>
        <span
          style={{
            fontSize: "0.9em",
          }}
        >
          {hit?.[path_key]}
        </span>
        <p>
          <Snippet attribute={text_key} hit={hit} />
        </p>
      </a>
    );
  }

  return (
    !!initialQuery && (
      <div className="container">
        <InstantSearch
          searchClient={searchClient}
          initialUiState={{
            Website: {
              query: initialQuery,
              page: 1,
            },
          }}
          indexName="Website"
        >
          <Configure
            restrictSearchableAttributes={[title_key, text_key]}
            attributesToSnippet={[`${text_key}:40`]}
            snippetEllipsisText="…"
          />
          <SearchBox />
          <Pagination />
          <Hits hitComponent={Hit} />
          <Pagination />
        </InstantSearch>
      </div>
    )
  );
}
export default SearchResults;
